import React, { useEffect, useState } from "react";
import Header from "../common/Header";
import PageContainer from "../common/PageContainer";
import Tab from "../common/Tab/Tab";
import TabPage from "../common/Tab/TabPage";
import uniqid from "uniqid";
import { useQuery } from "@tanstack/react-query";
import { fetchWithToken } from "../../functions/fetch";
import LeaseList from "./LeaseList";
import RouteProtection from "../common/RouteProtection";
import { addSearchedFields } from "../../functions/lease";
import SearchBar from "../common/SearchBar";
import NewItemButton from "../common/NewItemButton";
import TopLine from "../common/TopLine";
import NewLeasePopUp from "./NewLeasePopUp";
import {
  Container,
  Flex,
  Select,
  Spacer,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import ReportTab from "./ReportTab/ReportTab";

const LeasePage = () => {
  const texts = ["全部租約", "目前租約", "過期租約", "報表下載"];
  const [tabIndex, setTabIndex] = useState(0);
  const [currentLeases, setCurrentLeases] = useState([]);
  const [overdueLeases, setOverdueLeases] = useState([]);

  // for searchBar
  const [unfilteredLeases, setUnfilteredLeases] = useState([]);
  const [filteredLeases, setFilteredLeases] = useState([]);

  const [newLeaseDefaultValues, setNewLeaseDefaultValues] = useState({});
  const [sortKey, setSortKey] = useState("roomNum");

  // for NewLeasePopUp

  const fetchLease = async () => {
    const res = await fetchWithToken(
      "GET",
      `${process.env.REACT_APP_BACKEND_HOST}/api/lease`,
    );
    const { leases } = res;
    // NOTE: change here if default sort is changed
    const sortedLeases = leases.sort(
      (a, b) => Number(a?.room?.roomNumber) - Number(b?.room?.roomNumber),
    );
    addSearchedFields(sortedLeases);

    const newOverdueLeases = sortedLeases.filter((l) => l.overdue);
    const newCurrentLeases = sortedLeases.filter((l) => !l.overdue);

    setOverdueLeases(newOverdueLeases);
    setCurrentLeases(newCurrentLeases);

    const options = [sortedLeases, newCurrentLeases, newOverdueLeases];
    setUnfilteredLeases(options[tabIndex]);

    return sortedLeases;
  };

  const sortWithSortKey = (leases, sortKey) => {
    let sortFun = null;
    if (sortKey === "roomNum") {
      sortFun = (a, b) =>
        Number(a?.room?.roomNumber) - Number(b?.room?.roomNumber);
    } else if (sortKey === "date") {
      sortFun = (a, b) => {
        return new Date(a.endDate) - new Date(b.endDate);
      };
    } else {
      console.error(`Invalid sortKey: ${sortKey}`);
      return leases;
    }

    return leases.sort(sortFun);
  };

  const onChangeSortKey = (e) => {
    const newSortKey = e.target.value;
    setSortKey(newSortKey); // this will trigger useEffect and update every related lease
  };

  const { data: leases } = useQuery({
    queryKey: ["leases"],
    queryFn: fetchLease,
    initialData: [],
  });
  const { isOpen, onOpen, onClose } = useDisclosure();

  const renewLease = (defaultValues) => {
    onOpen();
    setNewLeaseDefaultValues(defaultValues);
  };

  const pages = [
    <LeaseList
      renewLease={renewLease}
      leases={filteredLeases}
      key={uniqid()}
    />,
    <LeaseList
      renewLease={renewLease}
      leases={filteredLeases}
      key={uniqid()}
    />,
    <LeaseList
      renewLease={renewLease}
      leases={filteredLeases}
      key={uniqid()}
    />,
    <ReportTab key={uniqid()} />,
  ];

  // update when tabIndex is updated
  useEffect(() => {
    const options = [
      sortWithSortKey(leases, sortKey),
      sortWithSortKey(currentLeases, sortKey),
      sortWithSortKey(overdueLeases, sortKey),
    ];
    // not using the leases
    if (tabIndex >= options.length) {
      return;
    }
    setUnfilteredLeases(options[tabIndex]);
    setFilteredLeases(options[tabIndex]);
  }, [tabIndex, sortKey]);

  return (
    <>
      <RouteProtection />
      <Header />
      <PageContainer>
        <div className="flex justify-between items-center">
          <Tab
            texts={texts}
            tabIndex={tabIndex}
            setTabIndex={setTabIndex}
            gridCol="grid-cols-[repeat(4,min-content)]"
          />
          {tabIndex !== 3 && (
            <SearchBar
              items={unfilteredLeases}
              setFunction={setFilteredLeases}
            />
          )}
        </div>
        <div>
          <TopLine />
          <NewLeasePopUp
            isOpen={isOpen}
            onClose={onClose}
            defaultValues={newLeaseDefaultValues}
          />
          <div className="mt-6">
            {
              // hide in report tab
              tabIndex !== 3 && (
                <Flex>
                  <NewItemButton itemName="租約" setShowPopUp={onOpen} />
                  <Spacer />
                  <Container display={"flex"} alignItems={"center"}>
                    <Text whiteSpace="nowrap" htmlFor="sortLeaseKey">
                      排序：
                    </Text>
                    <Select
                      id="sortLeaseKey"
                      value={sortKey}
                      onChange={onChangeSortKey}
                    >
                      <option value="roomNum">房號</option>
                      <option value="date">日期</option>
                    </Select>
                  </Container>
                </Flex>
              )
            }
            <TabPage pages={pages} tabIndex={tabIndex} />
          </div>
        </div>
      </PageContainer>
    </>
  );
};

export default LeasePage;
